
export function toQuery(obj) {
    return Object
        .keys(obj)
        .map(k => {
            if (obj[k] !== null && obj[k] !== undefined) {
                if (Array.isArray(obj[k])) {
                    return obj[k]
                        .map(x => obj[k] !== null && obj[k] !== undefined ? encodeURIComponent(k) + '=' + encodeURIComponent(x) : null)
                        .filter(x => x)
                        .join('&')
                }
                return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
            }
            return null
        })
        .filter(x => x)
        .join('&');
}

export function toKeyValueArray(obj, getKeyFunc, getValueFunc) {
    return Object.entries(obj).map(x => {
        return {
            key: getKeyFunc ? getKeyFunc(x[0]) : x[0],
            value: getValueFunc ? getValueFunc(x[1]) : x[1]
        };
    })
}

export function toQueryWithQuestionMark(obj) {
    return '?' + toQuery(obj)
}

export function groupBy(array, predicate) {
    if (array == null) {
        throw new TypeError('array is null or not defined');
    }
    if (typeof predicate !== 'function') {
        throw new TypeError(predicate + ' is not a function!');
    }
    const group = {};
    array.forEach((x) => {
        let key = predicate(x);
        if (!group[key]) {
            group[key] = [];
        }
        group[key].push(x);
    });
    return group;
}